export default {
    fire_origin: {
        name: "Fire Origin",
        url: "nwcg_fire/fire_origin",
    },
    hot_spot_spot_fire: {
        name: "Hot Spot Spot Fire",
        url: "nwcg_fire/hot_spot_spot_fire",
    },
}
